module.exports = __webpack_public_path__ + "static/media/hero-img.ed1bb50a.png";